/** An unread badge's count, as the header's badges and the support
 * bubble show it: past nine it reads 9+. */
export const badgeCount = (count: number) => (count > 9 ? '9+' : count);
